export const GRID = "grid";
export const TILES = "tiles";
export const CHART = "chart";
